import { Redirect } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { useUser } from '../../context/user/index.js';
import {loginRequest} from "../../config/authConfig";
import {
  LoginWrapper,
  LogoAndTitleWrapper,
  Logo,
  Title,
  ButtonWrapper,
  SubmitButton,
  LoginScreenWrapper,
} from './styles';
import logoHD from '../../resources/logo_higher_resolution.png';

const LoginScreen = () => {
  const { instance } = useMsal();
  const { user } = useUser();
  const isAuthenticated = useIsAuthenticated();

  const handleLoginMS = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch(e => {
        console.log(e);
      });
    }
  };

  if (isAuthenticated && user) {
    return <Redirect to='/home' />; // temporary - refactor so that it will redirect to the location that the user came from
  }

  return (
    <LoginScreenWrapper>
      <LoginWrapper>
        <LogoAndTitleWrapper>
          <Title>CAST</Title>
          <Logo src={logoHD} />
        </LogoAndTitleWrapper>
        <ButtonWrapper>
          <SubmitButton
            title='Login'
            onClick={() => handleLoginMS("popup")}
          />
        </ButtonWrapper>
      </LoginWrapper>
    </LoginScreenWrapper>
  );
};

export default LoginScreen;
